import { INotice } from '../../../interfaces';

class NoticeMapper {
    toPersistence(domainNotice: INotice): any {
        return {
            id: domainNotice.id,
            title: domainNotice.title,
            content: domainNotice.content,
            county_id: domainNotice.city_id,
            status: domainNotice.status,
            created_at: domainNotice.created_at,
            updated_at: domainNotice.created_at,
        }
    }

    toDomain(persistenceNotice: any): INotice {
        return {
            id: persistenceNotice.id,
            title: persistenceNotice.title,
            content: persistenceNotice.content,
            status: persistenceNotice.status,
            city_id: persistenceNotice.county_id,
            created_at: persistenceNotice.created_at,
            updated_at: persistenceNotice.created_at,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new NoticeMapper();
